// src/modules/reports/store/index.ts

import { getModuleSelectionReports, getUniqueForgeModelIds } from "@/modules/reports/api"; // <-- тут подключаем методы для отчетов

import { dispatchNotification } from "@/modules/common/utils/notifications";

export default {
  namespaced: true,
  state: {
    // ==== Новая секция для REPORTS ====
    DATA_REPORTS: [],
    TOTAL_REPORTS: 0,
    UNIQUE_FORGE_MODEL_IDS: [],
  },

  getters: {
    // ==== getters для REPORTS ====
    GET_REPORTS: (state: any) => state.DATA_REPORTS,
    GET_TOTAL_REPORTS: (state: any) => state.TOTAL_REPORTS,
    GET_UNIQUE_FORGE_IDS: (state: any) => state.UNIQUE_FORGE_MODEL_IDS,
  },

  mutations: {
    SET_REPORTS(state: any, data: any) {
      state.DATA_REPORTS = data;
    },
    SET_TOTAL_REPORTS(state: any, data: any) {
      state.TOTAL_REPORTS = data;
    },
    SET_UNIQUE_FORGE_IDS(state: any, data: any) {
      state.UNIQUE_FORGE_MODEL_IDS = data;
    },
  },

  actions: {
    async FETCH_REPORTS(context: any, payload: any) {
      try {
        const res = await getModuleSelectionReports(payload);
        if (res.status === 200) {
          context.commit("SET_TOTAL_REPORTS", res.data.total);
          context.commit("SET_REPORTS", res.data.items);
        }
      } catch (error: any) {
        console.log(`Error FETCH_REPORTS => ${error}`);
      }
    },

    async FETCH_UNIQUE_FORGE_MODELS(context: any) {
      try {
        const res = await getUniqueForgeModelIds();
        if (res.status === 200) {
          context.commit("SET_UNIQUE_FORGE_IDS", res.data.items);
        }
      } catch (error: any) {
        console.log(`Error FETCH_UNIQUE_FORGE_MODELS => ${error}`);
      }
    },
  },
};
